import React, { useState, useEffect, useRef } from 'react';
import './Enumerator.css';

import shoppingImage1 from './images/smart-home_10995332.png';
import shoppingImage2 from './images/customize_17427407.png';
import shoppingImage3 from './images/hard-work_12459171.png';
import shoppingImage4 from './images/time_11891411.png';
import shoppingImage5 from './images/house_613006.png';

const shoppingData = [
  { id: 1,
     name: 'Aproveitamento máximo de espaço',
      days: 'Utilize cada centímetro disponível, incluindo cantos e áreas irregulares. Eles são projetados para se encaixar perfeitamente no ambiente, o que é ideal para espaços pequenos ou com layout incomum',
       hours: '',
        image: shoppingImage1 },
  { id: 2,
     name: 'Personalização total',
      days: 'Escolha o material, cor, acabamento e a configuração interna dos móveis. Isso permite criar uma solução única que atende exatamente às suas necessidades e ao seu estilo pessoal, garantindo que o resultado final seja funcional, em harmonia com seu ambiente e esteticamente agradável',
       hours: '',
        image: shoppingImage2 },
  { id: 3,
      name: 'Organização eficiente',
       days: 'Com divisórias, prateleiras, gavetas e seções pensadas para o seu dia a dia, os móveis planejados ajudam a manter a ordem e facilitam a organização de roupas, utensílios e outros itens, evitando a bagunça e aumentando o ganho de tempo. Cada coisa no seu lugar, fácil de encontrar',
        hours: '',
         image: shoppingImage3 },
  { id: 4,
     name: 'Durabilidade e qualidade',
      days: 'Nossos móveis planejados são feitos com materiais de alta qualidade e com um processo de fabricação mais rigoroso. Isso resulta em móveis mais resistentes e duráveis em comparação com opções pré-fabricadas',
       hours: '',
        image: shoppingImage4 },
  { id: 5,
     name: 'Valorização do seu imóvel',
      days: 'Ambientes com móveis planejados e com design adequado aumentam o valor de mercado de uma propriedade. Eles são vistos como um diferencial, pois oferecem um espaço mais organizado e moderno, sendo percebitos como vantagens pelos compradores. É comprar, entrar e morar!',
       hours: '',
        image: shoppingImage5 },
];

const OndeEstamos = () => {
  const [visibleCards, setVisibleCards] = useState([]);
  const componentRef = useRef(null);

  useEffect(() => {
    let timeoutId = null;

    const animateCard = (index) => {
      // Se todos os cards já foram exibidos, para a animação.
      if (index >= shoppingData.length) {
        return;
      }

      // Adiciona o card atual ao estado.
      setVisibleCards(prevCards => [...prevCards, shoppingData[index].id]);

      // Chama a função recursivamente para o próximo card após 0.5 segundos.
      timeoutId = setTimeout(() => {
        animateCard(index + 1);
      }, 900); // <-- Ajustado para 500ms (0.5 segundos)
    };

    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;

        if (entry.isIntersecting) {
          // Limpa timers anteriores para evitar duplicações.
          clearTimeout(timeoutId);
          // Inicia a animação com o primeiro card após 1 segundo.
          setTimeout(() => animateCard(0), 1000);
        } else {
          // Limpa o timer e reseta o estado.
          clearTimeout(timeoutId);
          setVisibleCards([]);
        }
      },
      {
        threshold: 0.3, // <-- Ajustado para 0.7 (70%)
      }
    );

    if (componentRef.current) {
      observer.observe(componentRef.current);
    }

    return () => {
      clearTimeout(timeoutId);
      if (componentRef.current) {
        observer.unobserve(componentRef.current);
      }
    };
  }, []);

  return (
    <div className="contact-section" ref={componentRef}>
      <h1 className="contact-title">Ainda na dúvida?</h1>
      <p className="contact-subtitle">Entenda porquê móveis planejados são um grande negócio</p>

      <div className="shopping-cards-container">
        {shoppingData.map((shopping) => (
          <div
            className={`shopping-card ${visibleCards.includes(shopping.id) ? 'card-visivel' : 'card-oculto'}`}
            key={shopping.id}
          >
            <div
              className="card-background-image"
              style={{ backgroundImage: `url(${shopping.image})` }}
            ></div>
            <div className="card-content-overlay">
              <h2 className="card-title">{shopping.name}</h2>
              <p className="card-days">{shopping.days}</p>
              <p className="card-hours">{shopping.hours}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OndeEstamos;